export default {
  name: 'U.S. Virgin Islands',
  phonePattern: '',
  postalCodePattern: '111111111',
  singlePostalCode: '',
  postalCodeRegex: '^[\\d]{5,9}$',
  language: '',
  dobFormat: 'MM DD YYYY'
}



// WEBPACK FOOTER //
// ./src/locales/countries/VI.js